import { useState } from 'react';
// import { ChevronDown, ChevronRight, Link as LinkIcon } from 'lucide-react';
import './Accordion.css';
import React from 'react'
import { 
  Home as HomeIcon,
  MapPin as MapPinIcon,
  FileText as FileTextIcon,
  Phone as PhoneIcon,
  ChevronDown,
  ChevronRight,
  Menu,
  X,
  ExternalLink
} from 'lucide-react';

const Accordion = ({ items, icon }) => {
  const [openIndex, setOpenIndex] = useState(null);

  const toggleItem = (index) => {
    setOpenIndex(openIndex === index ? null : index);
  };

  const defaultIcon = <FileTextIcon size={20} className="mr-3 text-green-600" />;

  return (
    <div className="w-full max-w-4xl mx-auto environmental-theme">
      {items.map((item, index) => (
        <div key={index} className="accordion-item">
          <div className="accordion-header" onClick={() => toggleItem(index)}>
            <div className="flex items-center">
              {icon || defaultIcon}
              <span>{item.title}</span>
            </div>
            {openIndex === index ? (
              <ChevronDown size={24} className="text-green-600" />
            ) : (
              <ChevronRight size={24} className="text-gray-500" />
            )}
          </div>
          {openIndex === index && (
            <div className="accordion-content">
              {typeof item.content === 'string' ? (
                <p dangerouslySetInnerHTML={{ __html: item.content }}></p>
              ) : (
                item.content
              )}
            </div>
          )}
        </div>
      ))}
    </div>
  );
};

export default Accordion;